import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
// Using motion.button for built-in animation capabilities
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-brand-primary text-slate-950 hover:bg-brand-secondary shadow-lg shadow-amber-500/20 border border-transparent font-bold',
    secondary: 'bg-slate-800 text-white hover:bg-slate-700 border border-transparent font-medium',
    outline: 'bg-transparent border-2 border-slate-200 text-slate-900 hover:border-brand-primary hover:text-brand-primary font-medium',
    ghost: 'bg-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-100 font-medium',
    danger: 'bg-brand-accent text-white hover:bg-rose-700 shadow-lg shadow-rose-500/20 border border-transparent font-bold'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} ref={ref as any} className={cn('inline-flex items-center justify-center rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props as any} data-id="element-263" />;
});
Button.displayName = 'Button';